import { Button } from "@/components/ui/button";
import ConfirmActionDialog from "./ConfirmActionDialog";
import { useConfirmedAction } from "./useConfirmedAction";

interface RollbackActionProps {
  useCaseId: string;
  useCaseLabel: string;
  writable: boolean;
  onRollback: (useCaseId: string) => Promise<unknown>;
}

const RollbackAction = ({ useCaseId, useCaseLabel, writable, onRollback }: RollbackActionProps) => {
  const action = useConfirmedAction(() => onRollback(useCaseId));
  return (
    <>
      <Button size="sm" variant="outline" disabled={!writable} onClick={() => action.setOpen(true)}>
        Roll back
      </Button>
      <ConfirmActionDialog
        open={action.open}
        onOpenChange={action.setOpen}
        title={`Roll back ${useCaseLabel}?`}
        description="This removes the admin's choice and goes back to the previous setting. The change reaches staging and production at the next data push."
        confirmLabel="Yes, roll back"
        pending={action.pending}
        destructive
        onConfirm={action.confirm}
      />
    </>
  );
};

export default RollbackAction;
